export const getAbsoluteUrl = (path) => {
  const url = document.location;
  const baseUrl = url.protocol + '//' + url.host;
  return baseUrl + path;
};
